import React from 'react'
import PropTypes from 'prop-types'
import { Box, Loading } from '@maui/elements'
import isEmpty from 'lodash/isEmpty'

import { ServiceDetailsListGrid } from './ServiceDetailsListGrid'
import { ServiceDetailsSummary } from './ServiceDetailsSummary'
import { ServiceDetailsTabs } from './ServiceDetailsTabs'

const ServiceDetailsListGridMemo = React.memo(ServiceDetailsListGrid)

const ServiceDetails = ({ data, error }) => {
  const {
    id,
    description,
    comments,
    customer_attachments: customerAttachments,
    mandiant_attachments: mandiantAttachments
  } = data
  if (isEmpty(data) && !error) return <Box height={300}><Loading /></Box>
  if (error) return <Box height={300}>Error fetching case, please try again.</Box>
  return (
    <Box color="colorTextMain">
      <ServiceDetailsSummary description={description} />
      <Box mt="10px">
        <ServiceDetailsListGridMemo {...data}/>
      </Box>
      <Box mt="10px">
        <ServiceDetailsTabs
          caseId={id}
          comments={comments}
          customerAttachments={customerAttachments}
          mandiantAttachments={mandiantAttachments}
        />
      </Box>
    </Box>
  )
}

ServiceDetails.propTypes = {
  data: PropTypes.object.isRequired,
}

export default ServiceDetails
